export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">
              关于51影院
            </h2>
            <div className="prose prose-sm max-w-2xl mx-auto text-foreground-600 leading-relaxed space-y-4">
              <p>
                <strong className="text-foreground-900">51影院</strong>致力于为影迷打造一站式的免费高清观影平台。我们汇聚了<strong className="text-foreground-900">6080影院</strong>、<strong className="text-foreground-900">小a影院</strong>、<strong className="text-foreground-900">8090影院</strong>、<strong className="text-foreground-900">4480影院</strong>等全网优质影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。
              </p>
              <p>
                平台采用先进的视频加速技术，确保<strong className="text-foreground-900">超清画质</strong>流畅播放，真正实现<strong className="text-foreground-900">免广告不缓冲</strong>的纯净观影体验。每日同步更新最新院线大片和热播剧集，始终与主流平台保持内容同步。无需注册、无需登录，打开即可在线观看，让每一位影迷都能轻松畅享精彩影视内容。
              </p>
              <p>
                我们持续优化播放体验和内容覆盖面，用技术驱动观影品质，让<strong className="text-foreground-900">免费在线观看</strong>不再妥协于画质和流畅度。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}